import { Option } from '@sapphire/result';
import { ChildSurveysRequest, Survey, SurveyKind } from '@ps/survey-utils';

export function childSurveysRequest(
  survey: Survey,
): Option<ChildSurveysRequest> {
  return SurveyKind.childFilter(survey).map((filter) => ({
    filter,
    options: { targeting: 1 },
  }));
}

export function redirectsWhenChildless(survey: Survey): boolean {
  return SurveyKind.isTraditionalMc(survey);
}
